import { wsClient } from './ws-client';
import { authorizationService } from '../modules/authorization/authorization.service';

const getToken = async () => {
  let token = localStorage.getItem('accessToken');

  const [_, payload] = token ? token.split('.') : [];
  const payloadJson = payload ? atob(payload) : null;
  const payloadData = payloadJson ? JSON.parse(payloadJson) : null;

  if (!payloadData || Date.now() >= payloadData.exp * 1000) {
    const accessToken = await authorizationService.refreshToken();
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      token = accessToken;
    } else {
      if (location.pathname !== '/login') {
        // window.location.reload();
      }
    }
  }

  return token;
};

export const makeRequest = async ({ query, variables, operationName }) => {
  return wsClient
    .iterate({ query, variables: { ...variables, token: await getToken() }, operationName })
    .next()
    .then(({ value }) => value);
};

export const subscribe = async ({ query, variables, operationName }) => {
  return wsClient.iterate({ query, variables: { ...variables, token: await getToken() }, operationName });
};
